import { render, staticRenderFns } from "./ManagePrograms.vue?vue&type=template&id=20a3d84c&scoped=true"
import script from "./ManagePrograms.vue?vue&type=script&lang=js"
export * from "./ManagePrograms.vue?vue&type=script&lang=js"
import style0 from "./ManagePrograms.vue?vue&type=style&index=0&id=20a3d84c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a3d84c",
  null
  
)

export default component.exports